<!--基础信息-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-card class="all-card-style " >

      <a-form-model  :rules="FormRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :model="EntInfo" ref="EntInfo">
        <a-row>
          <a-col :span="8">logo配置(120x50)
          </a-col>
        </a-row>

<a-row>
  <a-col :span="8">
    <a-form-model-item  label="LOGO" class="ant-form-item2">
      <a-upload
        :action="uploadurl"
        list-type="picture"
        :default-file-list="fileList"
        @change="uploadchange"
      >
        <a-button> <a-icon type="upload" /> upload </a-button>
      </a-upload>

    </a-form-model-item>
  </a-col>
</a-row>



        <a-row>
          <a-col :span="8">小程序Banner图配置(750x236)
          </a-col>
        </a-row>



          <a-row>
            <a-col :span="8">
              <a-form-model-item  label="Banner" class="ant-form-item2">
                <a-upload
                  :action="uploadurl"
                  list-type="picture"
                  :default-file-list="fileList2"
                  @change="uploadchange2"
                >
                  <a-button> <a-icon type="upload" /> upload </a-button>
                </a-upload>

              </a-form-model-item>
            </a-col>
          </a-row>











        <a-row>
          <a-col :span="8">气象站配置
          </a-col>

        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="设备"  prop="cSceneCode"  class="ant-form-item2 " >
              <a-select v-model="DeviceID" @change="deviceGFJSelect"   class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in deviceGFJSelectItems" :value="item.ID">
                  {{item.DeviceAsName}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  >
          <a-col :span="8">
            <a-form-model-item label="传感器"  prop="cSceneCode"  class="ant-form-item2 " >
              <!--   <a-select v-model="sb1" @change="deviceGFJSelect"   class="ant-form-item3"  >
                   <a-select-option v-for="(item,index) in deviceGFJSelectItems" :value="item.ID">
                     {{item.DeviceAsName}}
                   </a-select-option>
                 </a-select>-->
              <a-select class="ant-form-item3"
                        mode="multiple" v-model="rList">
                <a-select-option v-for="(item,index) in controllerGFJSelectItems" :value="item.ID" >
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>




        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" @click="SaveForms" html-type="button">
            保存
          </a-button>
        </a-form-model-item>

      </a-form-model>

    </a-card>


  </div>
</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData } from '@/common/request'

  export default {
    name: 'basicInformationList',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1: "系统管理",
        titleMsg2:'数据配置',
        titleMsg3:'数据配置',
        EntInfo:{},
        LOGO:[],   uploadurl:"",fileList:[],
        fileList2:[],
        Banner:[],
        BannerInfo:[],
        rList2:[],

        FormRules:{

          cEntCode:
            [
              { required: true, message: '请输入企业编码', trigger: 'blur' }
            ],
          cEntName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' }
          ],
          cEntNature:[
            { required: true, message: '请选择企业性质', trigger: 'change' }
          ],
          dEstblDate:[
            { required: true, message: '请选择成立日期', trigger: 'blur' }
          ],
          cChargeUser:[
            { required: true, message: '请输入负责人', trigger: 'blur' }
          ]

        },
        deviceGFJSelectItems:[],
        deviceJXGLQSelectItems:[],
        deviceSBSelectItems:[],
        deviceSBOSelectItems:[],
        deviceZWXSelectItems:[],
        geoshow:false,
        controllerGFJSelectItems:[],
        controllerJXGLSelectItems:[],
        controllerSBSelectItems:[],
        controllerSBOSelectItems:[],
        controllerZWXSelectItems:[],
        DeviceID:'',
        rList:[],
      }
    },
    mounted () {
      this.uploadurl=this.$http.defaults.baseURL+"User/Upload";
      this.EntInfo.ID=this.$store.getters.User.enterprise.ID;
      this.getDeviceIDSelectItems();
      this.HandleDetail();
      this.HandleDetail2();

    },
    methods:{






      uploadchange2(e){

        console.log(e);
        console.log(e.fileList[0]);
        console.log(e.fileList[0].response);
        let that=this;
        that.rList2=[];
        for (let i in e.fileList){
          try{
            that.rList2.push(e.fileList[i].response.Id);
          }catch(e1){}
        }
        // that.rList2.push(e.file.response.Id);
      },

      async HandleDetail2(){
        var that=this
        let res=await that.$http.post('/DataConfig/FindBannerByWhere',{
          cEntID:this.$store.getters.User.enterprise.ID,
          cSystemCode:'设施园艺'
        })
        if(res.data.code=="200"){
          that. BannerInfo=res.data.obj.data;
          let _rList2=[];
          let cInfos=JSON.parse(that.BannerInfo.cBanners)
          if(!!cInfos){
            for(let i in cInfos){
              _rList2.push(cInfos[i]);

              that.fileList2.push({
                uid: that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+cInfos[i],
                name: '0.png',
                status: 'done',
                response: '', // custom error message to show
                url: that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+cInfos[i],
              })

            }
            that.rList2=_rList2;

          }
        }},

      uploadchange(e){
        let that=this;

        if (e.file){

          console.log(e);
console.log(that.LOGO);
        that.LOGO=that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+e.file.response.Id;
        }
console.log('dsdf',that.fileList);
      },
      async getDeviceIDSelectItems(){
        let that=this;
        let res = await this.$http.post('WLWDevice/List', {
          cEntID:that.$store.getters.User.enterprise.ID,
          sceneId:'',cSystemCode:'设施园艺'
        });
        that.deviceGFJSelectItems = res.data.obj.list;
        that.deviceJXGLQSelectItems = res.data.obj.list;
        that.deviceSBSelectItems = res.data.obj.list;
        that.deviceSBOSelectItems = res.data.obj.list;
        that.deviceZWXSelectItems = res.data.obj.list;
      },
      async deviceGFJSelect(obj){

        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesR?cDeviceID='+obj,{});
        if(res.data.code=='200'){
         that.controllerGFJSelectItems=res.data.obj.list;
       that.controllerJXGLSelectItems=res.data.obj.list;
         that.controllerSBSelectItems=res.data.obj.list;
       that.controllerSBOSelectItems=res.data.obj.list;
       that.controllerZWXSelectItems=res.data.obj.list;
        }
      },
      toAddPage(){
        // this.$router.push({path:'/equipment/equipmentDetails'});

      },
      async HandleDetail(){
        /*获取项目列表*/

        var that=this
        let res=await that.$http.post('/DataConfig/FindByWhere',{
          cEntID:this.$store.getters.User.enterprise.ID,
          cSystemCode:'设施园艺'
        })


        if(res.data.code=="200"){

          that.EntInfo=res.data.obj.data;

          let _rList=[];
          let cInfos=JSON.parse(that.EntInfo.cInfos)
          that.DeviceID=cInfos.DeviceID;
          that.deviceGFJSelect(that.DeviceID        );
          if(!!cInfos){
          for(let i in cInfos.rList){
            _rList.push(cInfos.rList[i].ID);
          }
          that.rList=_rList;
            that.LOGO=cInfos.LOGO
            that.fileList=[{
              uid: that.LOGO,
              name: '0.png',
              status: 'done',
              response: '', // custom error message to show
              url: cInfos.LOGO,
            }]

          }
          console.log('   that.fileList',   that.fileList);
       try{

       }catch (e) {

       }


        }


      },
      //保存权限
      async SaveForms () {
        let that = this;

        that.$refs['EntInfo'].validate(async valid => {

          if (valid) {
            that.EntInfo.cEntID=this.$store.getters.User.enterprise.ID;
            that.EntInfo.cSystemCode='设施园艺';
            let _rList=[];
            for(let i in that.rList){
              _rList.push({ID:that.rList[i]});
            }
            var _p={
              DeviceID:that.DeviceID,
              rList:_rList,
              LOGO:that.LOGO
            };
            that.EntInfo.cInfos=JSON.stringify(_p);
            let res = await that.$http.post('DataConfig/Save', that.EntInfo)


            that. BannerInfo.cEntID=         that.EntInfo.cEntID;
            that.BannerInfo.cSystemCode='设施园艺';
            that.BannerInfo.cBanners=JSON.stringify(  that.rList2);
            let res2 = await that.$http.post('DataConfig/BannerSave', that.BannerInfo)



            if (res.data.code == "200") {
              that.$message.success('保存成功!')

            } else {
              that.$message.error(res.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>

<style>
  .emal-table-box{
    margin-top: 32px;
  }
</style>
